export default "__VITE_ASSET__a76e5385__"